import { render, staticRenderFns } from "./FormKeywordModal.vue?vue&type=template&id=40e0533e&scoped=true&"
import script from "./FormKeywordModal.vue?vue&type=script&lang=js&"
export * from "./FormKeywordModal.vue?vue&type=script&lang=js&"
import style0 from "./FormKeywordModal.vue?vue&type=style&index=0&id=40e0533e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e0533e",
  null
  
)

export default component.exports